export const stopAllAudioAndMute = () => {
  const allAudio = document.querySelectorAll('audio')
  allAudio.forEach(audio => {
    audio.volume = 0
  })
}
